export default __webpack_public_path__ + "static/logo-802a7947e1d9760d9af06a3b926cdaa1.jpg";